export default "__VITE_ASSET__UxCFHf9d__"